<app-page-shell variant="default">
<div class="card card-box mb-5">
      <div class="card-header py-3">
        <div class="card-header--title trial-register font-size-lg d-flex align-items-center w-100">
          Manage Clients
          <div class='d-flex ms-4 align-items-center trail-register-input w-50'>
            <label class='d-inline'> Trial Register For New Users</label>
            <input  class="form-control" [value]='trialRegister()' disabled
                   type="text"/>
            <i class="fa fa-copy" aria-hidden="true" (click)="copyLinkToClipboard()"></i>
          </div>
        </div>
        @if (currentUser()?.can('create', 'client')) {
        <div class="card-header--actions">
          <a class="btn btn-primary btn-sm" [routerLink]="['/clients/add']" sbEntityLink role="button">
            <span class="btn-wrapper--icon"><i class="fa fa-plus"></i></span>
            <span class="btn-wrapper--label">Add New Client</span>
          </a>
        </div>
        }
      </div>

      <div class="p-3">
        <app-sb-table
          [rows]="clients()"
          [totalRows]="totalClients()"
          [columns]="tableColumns"
          [options]="tableOptions"
          (stateChange)="onTableState($event)">

          <div class="d-flex flex-wrap" sbTableFilterExtra>
            <div class="package-dropdown me-3">
              <app-creatable-select
                [hideLabel]="true" [isCreatable]="false" [onlyBottomBorder]="false"
                [placeholder]="'Select Organization'" [selectOptions]="organizations()"
                (optionSelected)="clientListByOrganization($event)"></app-creatable-select>
            </div>
            <div class="package-dropdown">
              <app-creatable-select
                [hideLabel]="true" [isCreatable]="false" [onlyBottomBorder]="false"
                [placeholder]="'Select Package'" [selectOptions]="packages()"
                (optionSelected)="clientListByPackage($event)"></app-creatable-select>
            </div>
          </div>

          <ng-template sbTableCell="logo" let-client>
            <img class="logo-thumbnail" [src]="client.logo" alt=""/>
          </ng-template>
          <ng-template sbTableCell="name" let-client><div class="word-break">{{client.name}}</div></ng-template>
          <ng-template sbTableCell="email" let-client>{{client.email || ''}}</ng-template>
          <ng-template sbTableCell="organization" let-client>{{client.organization?.name || '-'}}</ng-template>
          <ng-template sbTableCell="package" let-client>{{client.package?.name || ''}}</ng-template>
          <ng-template sbTableCell="package_start_date" let-client>{{formatMomentDate(client.package_start_date)}}</ng-template>
          <ng-template sbTableCell="package_end_date" let-client>{{formatMomentDate(client.package_end_date)}}</ng-template>
          <ng-template sbTableCell="created_at" let-client>{{formatMoment(client.created_at)}}</ng-template>
          <ng-template sbTableCell="projects" let-client>
            <div class="cursor-pointer" (click)="onClickProjects(client)">
              <span>Projects</span>
            </div>
          </ng-template>

          <ng-template sbTableActions let-client>
            <button class="btn-icon float-end" mat-icon-button [matMenuTriggerFor]="menu"
                    aria-label="Example icon-button with a menu">
              <span class="fa fa-ellipsis-v"></span>
            </button>
            <mat-menu #menu="matMenu" class="campaign-popover">
              <a class="dropdown-item" [routerLink]="['/clients/edit', client.id]" sbEntityLink>
                <i class="fa fa-pencil me-2"></i>Edit</a>
              <a class="dropdown-item" (click)="deleteClient(client)">
                <i class="fa fa-trash me-2"></i>Delete</a>
            </mat-menu>
          </ng-template>
        </app-sb-table>
      </div>
</div>
</app-page-shell>
